import React, { useRef, useContext, useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Paper,
  Button,
  ClickAwayListener,
  Grow,
  Popper,
  MenuList,
  MenuItem,
  InputBase,
  IconButton,
  Divider,
} from "@material-ui/core";
import { Search as SearchIcon } from "@material-ui/icons";

// Contexts
import OrderContext from "../../../../context/orders/v1/OrdersContext";

// Material UI Styling
const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
  },
  divider: {
    height: 28,
    margin: 4,
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    fontSize: "0.9rem",
  },
  iconButton: {
    padding: 10,
  },
}));

const OrderSearchBar = () => {
  const classes = useStyles();

  const { searchFilter, setSearchFilter, searchOrder } =
    useContext(OrderContext);

  const [errorMsg, setErrorMsg] = useState();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (e) => {
    if (anchorRef.current && anchorRef.current.contains(e.target)) {
      return;
    }

    setOpen(false);
  };

  const handleListKeyDown = (e) => {
    if (e.key === "Tab") {
      e.preventDefault();
      setOpen(false);
    }
  };

  const handleSelect = (e) => {
    setSearchFilter({
      by: e.target.id,
      value: "",
    });
    handleClose(e);
  };

  const handleChange = (e) => {
    setSearchFilter({ ...searchFilter, value: e.target.value.trim() });

    if (e.target.value) {
      setErrorMsg();
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();

    if (searchFilter.value !== "") {
      searchOrder();
    } else {
      setErrorMsg(`Enter ${searchFilter.by} To Search`);
    }
  };

  // Update Error Message According To Selected Filter
  useEffect(() => {
    if (errorMsg) {
      setErrorMsg(`Enter ${searchFilter.by} To Search`);
    }
  }, [errorMsg, searchFilter.by]);

  return (
    <Paper component="form" className={classes.paper}>
      {" "}
      {/* Menu */}{" "}
      <Button
        color="primary"
        style={{
          textTransform: "none",
          width: "8rem",
        }}
        ref={anchorRef}
        aria-controls={open ? "search-by-list" : undefined}
        aria-haspopup={true}
        onClick={handleToggle}
      >
        {searchFilter.by}{" "}
      </Button>
      <Popper
        transition
        disablePortal
        role={undefined}
        anchorEl={anchorRef.current}
        open={open}
        style={{
          zIndex: 99,
        }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement,
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  id="search-by-list"
                  autoFocusItem={open}
                  onKeyDown={handleListKeyDown}
                >
                  <MenuItem id="Transaction ID" onClick={handleSelect}>
                    Transaction ID{" "}
                  </MenuItem>{" "}
                  <MenuItem id="Order Name" onClick={handleSelect}>
                    Order Name{" "}
                  </MenuItem>{" "}
                  <MenuItem id="Email" onClick={handleSelect}>
                    Email{" "}
                  </MenuItem>{" "}
                </MenuList>{" "}
              </ClickAwayListener>{" "}
            </Paper>{" "}
          </Grow>
        )}{" "}
      </Popper>
      <Divider className={classes.divider} orientation="vertical" />
      {/* Input */}{" "}
      <InputBase
        className={classes.input}
        style={{
          color: errorMsg ? "red" : "inherit",
          fontWeight: errorMsg ? "bold" : "normal",
        }}
        placeholder={errorMsg ? errorMsg : `Search By ${searchFilter.by}`}
        value={searchFilter.value}
        onChange={handleChange}
        error={errorMsg ? true : false}
      />
      <Divider className={classes.divider} orientation="vertical" />
      {/* Button */}{" "}
      <IconButton
        className={classes.iconButton}
        type="submit"
        onClick={onSubmit}
      >
        <SearchIcon />
      </IconButton>{" "}
    </Paper>
  );
};

export default OrderSearchBar;
